/* eslint-disable no-useless-escape */
/* eslint-disable react/no-unused-state */
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import YBPopupBuilderQuery from 'Query/YBPopupBuilder.query';
import {
    BILLING_URL, CHECKOUT_URL, DETAILS_URL_STEP, SHIPPING_URL_STEP
} from 'Route/Checkout/Checkout.config';
import { showPopup } from 'Store/Popup/Popup.action';
import { HistoryType, UrlRewriteType } from 'Type/Router.type';
import BrowserDatabase from 'Util/BrowserDatabase';
import { prepareQuery } from 'Util/Query';
import { executePost } from 'Util/Request';
import { ONE_MONTH_IN_SECONDS } from 'Util/Request/QueryDispatcher';
import getStore from 'Util/Store';
import { isHomePageUrl } from 'Util/Url';

import YBPopupBuilder from './YBPopupBuilder.component';
import { YB_POPUP_BUILDER } from './YBPopupBuilder.config';

/** @namespace Elganso/Component/YBPopupBuilder/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({

});

/** @namespace Elganso/Component/YBPopupBuilder/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    urlRewrite: state.UrlRewritesReducer.urlRewrite,
    getPopUpListConditions: state.ConfigReducer?.getPopUpListConditions
});

/** @namespace Elganso/Component/YBPopupBuilder/Container */
export class YBPopupBuilderContainer extends PureComponent {
    static propTypes = {
        urlRewrite: UrlRewriteType.isRequired,
        history: HistoryType.isRequired
    };

    state = {
        id: '',
        html: '',
        style: '',
        configuration: '',
        pathname: '',
        widget: '',
        hasPathname: ''
    };

    componentDidMount() {
        const {
            urlRewrite: { type },
            getPopUpListConditions
        } = this.props;

        if (getPopUpListConditions.length > 0) {
            this._findValidPopup(!!type);
            this.setState({ pathname: window.location.pathname });
            this.setState({ hasPathname: window.location.pathname });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { urlRewrite, getPopUpListConditions, urlRewrite: { type } } = this.props;
        const { pathname, hasPathname } = this.state;

        if (getPopUpListConditions.length > 0) {
            if (hasPathname === '') {
                this.setState({ pathname: window.location.pathname });
                this.setState({ hasPathname: window.location.pathname });
                this._findValidPopup(type);
            } else if (prevProps?.urlRewrite !== urlRewrite) {
                this.setState({ pathname: window.location.pathname });
                this.setState({ hasPathname: window.location.pathname });
                this._findValidPopup(type);
            } else if (window.location.pathname !== pathname && prevState?.pathname === window.location.pathname) {
                this.setState({ pathname: window.location.pathname });
                this.setState({ hasPathname: window.location.pathname });
                this._findValidPopup(type);
            } else if (window.location.pathname.includes(`${CHECKOUT_URL }/${ SHIPPING_URL_STEP}`) && window.location.pathname !== pathname) {
                this.setState({ pathname: window.location.pathname });
                this.setState({ hasPathname: window.location.pathname });
                this._findValidPopup(type);
            }
        }
    }

    handleShowPopup(id) {
        const { html, widget } = this.state;
        if (html === '' && widget === '\"\"') {
            return false;
        }

        const param = `${ YB_POPUP_BUILDER }_${ id }`;
        const cookiePopup = BrowserDatabase.getItem(param);

        if (cookiePopup) {
            const store = getStore();
            const { dispatch } = store;

            dispatch(showPopup('popupbuilder', { title: '' }));
        }

        return true;
    }

    containerProps() {
        const {
            id,
            html,
            style,
            widget
        } = this.state;

        return {
            id,
            html,
            style,
            widget
        };
    }

    _findValidPopup(isUrlRewrite) {
        const { getPopUpListConditions } = this.props;

        if (getPopUpListConditions) {
            const validPopupList = getPopUpListConditions.filter((popup) => this._isValid(popup, isUrlRewrite));

            if (validPopupList.length > 0) {
                this._checkTriggerAdvanced(validPopupList);
            }
        }
    }

    _saveCookie(id) {
        const param = `${ YB_POPUP_BUILDER }_${ id }`;
        const cookiePopup = BrowserDatabase.getItem(param);
        let times = 1;

        if (cookiePopup) {
            times += cookiePopup;
        }

        BrowserDatabase.setItem(times, param, ONE_MONTH_IN_SECONDS);
    }

    _checkCookies(id, times) {
        const param = `${ YB_POPUP_BUILDER }_${ id }`;
        const cookiePopup = BrowserDatabase.getItem(param);
        if (cookiePopup) {
            return parseInt(times, 10) > parseInt(cookiePopup, 10);
        }

        return true;
    }

    _checkTriggerAdvanced(popupList) {
        const popup = popupList[0];
        const triggerObject = JSON.parse(popup.trigger);

        // Trigger - On Page Load
        if (triggerObject.page_load === 1) {
            if ((triggerObject.times_times > 0) && (this._checkCookies(popup.id, triggerObject.times_times))) {
                const timeOut = triggerObject.page_load_delay > 0 ? triggerObject.page_load_delay * 1000 : 100;
                setTimeout(() => {
                    this._getPopupBuilderData(popup.id);
                }, timeOut);
            }
        }
        // Trigger - On Scroll
        if (triggerObject.scrolling === 1) {
            const body = document.getElementById('html-body');
            const direction = triggerObject.scrolling_direction;
            const offset = triggerObject.scrolling_offset;
            let lastScrollOffset = body.scrollTop;

            const scrolling = () => {
                let scrollDirection;

                if (body.scrollTop < lastScrollOffset) {
                    scrollDirection = 'up';
                } else {
                    scrollDirection = 'down';
                }

                lastScrollOffset = body.scrollTop;

                if (scrollDirection === direction) {
                    const fullScroll = body.clientHeight;
                    const scrollPercent = (body.scrollTop / fullScroll) * 100;

                    if ((scrollDirection === 'up' && scrollPercent <= offset) || (scrollDirection === 'down' && scrollPercent >= offset)) {
                        body.removeEventListener('scroll', scrolling);
                        this._getPopupBuilderData(popup.id);
                    }
                }
            };

            body.addEventListener('scroll', scrolling);
        }
        // Trigger - On Scroll To Element
        if (triggerObject.scrolling_to === 1) {
            const body = document.getElementById('html-body');
            const targetSelector = 'CategoryDetails-Heading';
            let targetElement = document.getElementById(targetSelector);

            if (!targetElement) {
                targetElement = document.getElementsByClassName(targetSelector)[0];
            }

            if (targetElement) {
                const scrolling = () => {
                    const fullScroll = targetElement.offsetTop - body.clientHeight;

                    if (body.scrollTop >= fullScroll) {
                        body.removeEventListener('scroll', scrolling);
                        this._getPopupBuilderData(popup.id);
                    }
                };

                body.addEventListener('scroll', scrolling);
            }
        }
        // Trigger - On Hover
        if (triggerObject.hover_on === 1) {
            setTimeout(() => {
                const targetSelector = triggerObject.hover_selector;
                let targetElement = document.getElementById(targetSelector);

                if (!targetElement) {
                    targetElement = document.getElementsByClassName(targetSelector)[0];
                }

                if (targetElement) {
                    const hoverElement = () => {
                        targetElement.removeEventListener('mouseover', hoverElement);
                        this._getPopupBuilderData(popup.id);
                    };

                    targetElement.addEventListener('mouseover', hoverElement);
                }
            }, 5000);
        }
        // Trigger - On Click
        if (triggerObject.click === 1) {
            const clickTimes = parseFloat(triggerObject.click_times);
            let clicksCount = 0;

            const onClickBody = () => {
                clicksCount++;

                if (clicksCount === clickTimes) {
                    document.removeEventListener('click', onClickBody);
                    this._getPopupBuilderData(popup.id);
                }
            };

            document.addEventListener('click', onClickBody);
        }
        // Trigger - After Inactivity
        if (triggerObject.inactivity === 1) {
            const inactivityTime = parseFloat(triggerObject.inactivity_time);
            let timeOut;

            const startTimer = () => {
                timeOut = setTimeout(() => {
                    this._getPopupBuilderData(popup.id);
                }, inactivityTime * 1000);
            };

            const clearTimer = () => {
                clearTimeout(timeOut);
            };

            const restartTimer = () => {
                clearTimer();
                startTimer();
            };

            document.addEventListener('keypress', restartTimer);
            document.addEventListener('mousemove', restartTimer);
            document.addEventListener('scroll', restartTimer);
        }
        // Trigger - On Page Exit Intent (cuando el cursor se mueva fuera del límite superior de la página)
        if (triggerObject.exit_intent === 1) {
            const body = document.getElementById('html-body');

            const showOnOutside = (e) => {
                if (e.clientY <= 0) {
                    body.removeEventListener('mouseleave', showOnOutside);
                    this._getPopupBuilderData(popup.id);
                }
            };

            body.addEventListener('mouseleave', showOnOutside);
        }
    }

    _isValidCondition(condition, isUrlRewrite) {
        const {
            location: { pathname },
            urlRewrite: { type, id }
        } = this.props;

        if ('status' in condition && condition.status === 'include') {
            switch (condition.page_group) {
            case 'cms_index_index':
                if (isHomePageUrl(pathname)) {
                    return true;
                }

                return false;
            case 'all_pages':
                if (type === 'CMS_PAGE') {
                    return true;
                }

                return false;
            case 'specific_pages':
                if (type === 'CMS_PAGE') {
                    if (String(condition.entities).split(',').find((val) => parseInt(val, 10) === id)) {
                        return true;
                    }
                }

                return false;
            case 'entireSite':
                return true;
            case 'anchor_categories':
                if (isUrlRewrite === 'CATEGORY') {
                    if (type === 'CATEGORY') {
                        if (String(condition.entities).split(',').find((val) => parseInt(val, 10) === id)) {
                            return true;
                        }
                    }
                    if (condition.page_group_type === 'all') {
                        return true;
                    }
                }

                return false;
            case 'checkout_index_index':
                if (pathname.includes(CHECKOUT_URL) && !pathname.includes(DETAILS_URL_STEP) && !pathname.includes(BILLING_URL)) {
                    return true;
                }

                return false;
            default:
                return false;
            }
        }

        return false;
    }

    _isValid(popup, isUrlRewrite) {
        const triggerObject = JSON.parse(popup.trigger);
        if (!triggerObject || !triggerObject?.conditions) {
            return false;
        }
        const { conditions } = triggerObject;
        const validConditions = conditions.filter((condition) => this._isValidCondition(condition, isUrlRewrite));
        if (validConditions.length > 0) {
            return true;
        }

        return false;
    }

    _getPopupBuilderData(ids) {
        const este = this;
        executePost(
            prepareQuery(YBPopupBuilderQuery.getPopupBuilderQuery(ids))
        ).then(
            /** @namespace Elganso/Component/YBPopupBuilder/Container/YBPopupBuilderContainer/_getPopupBuilderData/then/finally/executePost/then */
            (result) => {
                const resultPopupList = result.getPopUpList;
                this.setState({
                    id: resultPopupList[0].id,
                    html: resultPopupList[0].html,
                    style: resultPopupList[0].style,
                    configuration: resultPopupList[0].configuration,
                    widget: resultPopupList[0].widget
                });
            }
        ).finally(
            /** @namespace Elganso/Component/YBPopupBuilder/Container/YBPopupBuilderContainer/_getPopupBuilderData/then/finally */
            () => {
                this._saveCookie(ids);
                este.handleShowPopup(ids);
            }
        );
    }

    render() {
        return (
            <YBPopupBuilder
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(YBPopupBuilderContainer);
